import React, { memo, useCallback, useEffect } from 'react';
import { Button, Tabs, Form, message } from 'antd';

import { useRequest } from 'ahooks';
import { useDispatch } from 'react-redux';
import { ConBrandDetailsWebController } from '@/services/swagger/ConBrandDetailsWebController';
import { ConBrandWebController } from '@/services/swagger/ConBrandWebController';
import CoreTeamAbilityForm, { CoreTeamAbilityFormTeamFormValueType } from '../CoreTeamAbilityForm';
import { SupplyChainCompletenessFormValueType } from '../SupplyChainCompletenessForm';
import styles from './index.module.scss';

const { TabPane } = Tabs;
const controller = new ConBrandWebController();
const brandDetailController = new ConBrandDetailsWebController();

export type SupplyInfoContentProps = {
  conBrandId?: string;
  defaultActiveKey?: string;
};

const SupplyInfoContent: React.FC<SupplyInfoContentProps> = ({ conBrandId, defaultActiveKey }) => {
  const [coreTeamAbilityForm] = Form.useForm<CoreTeamAbilityFormTeamFormValueType>();
  const [supplyChainCompletenessForm] = Form.useForm<SupplyChainCompletenessFormValueType>();
  /** 组织能力 */
  const { data: organization } = useRequest(async () => {
    const res = await brandDetailController.conBrandDetailsWebControllerV1BrandDetailOrganUsingGet1({
      conBrandId,
    });
    return res.data.data;
  });
  /** 供应链管理能力 */
  const { data: supplyChain } = useRequest(async () => {
    const res = await controller.conBrandWebControllerV1SupplyChainUsingGet1({
      conBrandId,
    });
    return res.data.data;
  });
  useEffect(() => {
    if (organization?.conBrandGroupList.length) {
      coreTeamAbilityForm.setFieldsValue({
        brandGroupList: organization?.conBrandGroupList.map(item => {
          return {
            avatarUrl: item.avatarUrl,
            memberName: item.memberName,
            memberJob: item.memberJob,
            memberDesc: item.memberDesc,
          };
        }),
      });
    }
    if (supplyChain) {
      supplyChainCompletenessForm.setFieldsValue(supplyChain);
    }
  }, [coreTeamAbilityForm, organization?.conBrandGroupList, supplyChain, supplyChainCompletenessForm]);
  const dispatch = useDispatch();
  const { run } = useRequest(brandDetailController.conBrandDetailsWebControllerV1SupplementBrandUsingPut1, {
    manual: true,
    onSuccess(res) {
      if (res.data.code === 200 && res.data.errorCode === '00000') {
        message.success(res.data.msg);
        dispatch({ type: 'modal/close' });
      } else {
        message.error(res.data.msg);
      }
    },
  });
  const submit = useCallback(() => {
    const coreTeamAbilityFormValue = coreTeamAbilityForm.getFieldsValue();
    const supplyChainCompletenessFormValue = supplyChainCompletenessForm.getFieldsValue();
    const brandSupplyChain = Object.keys(supplyChainCompletenessFormValue).length
      ? supplyChainCompletenessFormValue
      : supplyChain;
    const brandGroupList = coreTeamAbilityFormValue.brandGroupList.filter(
      item => item && Object.values(item).some(v => !!v)
    );
    if (!brandGroupList.length) {
      message.error('请至少填写一项完整的核心团队信息信息');
      return;
    }
    if (brandGroupList.some(item => Object.values(item).some(v => !v))) {
      message.error('核心团队信息信息不完整');
      return;
    }
    run({ conBrandId, brandGroupList, brandSupplyChain });
  }, [conBrandId, coreTeamAbilityForm, run, supplyChain, supplyChainCompletenessForm]);
  return (
    <div className={styles.content}>
      <Tabs className={styles.tabs} tabPosition="left" defaultActiveKey={defaultActiveKey} tabBarGutter={0}>
        <TabPane className={styles.tabPane} key="coreTeam" tab="核心团队信息">
          <CoreTeamAbilityForm form={coreTeamAbilityForm} />
        </TabPane>
        {/*<TabPane className={styles.tabPane} key="supplyChain" tab="供应链完善程度">*/}
        {/*  <SupplyChainCompletenessForm*/}
        {/*    className={styles.supplyChainCompletenessForm}*/}
        {/*    form={supplyChainCompletenessForm}*/}
        {/*  />*/}
        {/*</TabPane>*/}
      </Tabs>
      <div className={styles.operation}>
        <Button className={styles.saveBtn} type="primary" onClick={submit}>
          保存
        </Button>
      </div>
    </div>
  );
};

export default memo(SupplyInfoContent);
